export default __webpack_public_path__ + "images/d8f762718436a076816bce1fe71eef50-downloadapp.png";